import { useTranslation } from "react-i18next";
import { Chip } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { MissionRequestEnumLists } from "../../../../common/constants";
import { GetMissionRequestResponseChipStyle } from "../../../../common/missionrequests";

const useStyles = makeStyles()(
  () => ({
    root: {
      fontWeight: 400
    },
  })
);

export default function MissionRequestStateChip(props) {
  const { response } = props;
  const { t } = useTranslation();
  const { classes } = useStyles();

  return (
    <Chip
      className={classes.root}
      label={t(`missionRequests:enums:responseState:${MissionRequestEnumLists.ResponseState[response || 0]}`)}
      style={GetMissionRequestResponseChipStyle(response)}
      variant="filled"
      size="small"
    />
  );
}

